// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3eYbu","alert":"SettungsInbox_alert__X6JGJ"};